// extracted by mini-css-extract-plugin
export default {"f":"_2a2b6101ef","main":"_4c8627a71e","btn":"_351de13f9b","w":"_8556a2c65b","h":"_66d0a34b32","lh25":"feb745fb3d","wb":"a91188af5e","b":"_3f419f2dcc","bx":"_3ddb3e0378"};